import Packet, { PacketType } from '../Packet'
import { EmbedBaseURLWithSchema } from '@/util/Serialization';
import ProjectServer from '../ProjectServer';
import { required } from 'vuelidate/lib/validators';

export class AsyncRequest<T>
{
    constructor(id : number, type : string, data : T)
    {
        this.requestID = id;
        this.requestType = type;
        this.data = data;
    }

    requestID : number;
    requestType : string;
    data : T;
}

export class AsyncResponse<T>
{
    constructor(id : number, type : string, data : T)
    {
        this.error = null;
        this.requestID = id;
        this.data = data;
    }

    requestID : number;
    data : T;
    error : any;
}

export default class AsyncRequests
{
    constructor( serv : ProjectServer )
    {
        this.server = serv;
    }

    private server : ProjectServer;
    private nextID = 0;
    private outRequests = new Map<number, { resolve : any, fail : any }>();

    handleResponsePacket(packet : Packet)
    {
        let resp = packet.data as AsyncResponse<any>;
        let promise = this.outRequests.get(resp.requestID);
        if (promise)
        {
            if (resp.error)
            {
                promise.fail(resp.error);
            }
            else
            {
                promise.resolve(resp.data);
            }
        }
        else
        {
            throw { error: "Received response for inexistent async request" }
        }
    }

    async SendRequest<R, T>(command : string, data : T)
    {
        const reqId = ++this.nextID;
        const request = new AsyncRequest(reqId, command, data);
        
        let resolve;
        let fail;
        const promise = new Promise((s, f)=>
        {
            resolve = s;
            fail = f;
        });

        this.outRequests.set(reqId, { resolve, fail });
        this.server.sendData(PacketType.AsyncRequest, request);
        return (await promise) as R;
    }

    async TestRPC(test : string)
    {
        return await this.SendRequest<Number, {test:string}>("testRPC", {test});
    }
}